import type { CarouselProductMapperInput } from '../mappers/common/carouselProductMapper';

import { API } from '@/services/api';
import { getOriginFromEnvironment } from '@/utilities/getOriginFromEnvironment';

export type RecommendationType = 'VISUALLY_SIMILAR' | 'OTHERS_ALSO_VIEWED';

export type CarouselVariables =
  | { identifiers: string[] }
  | { sku: string; type: RecommendationType };

type CarouselBody = {
  query: string;
  variables: CarouselVariables & { locale: string };
};

type CarouselResponse = {
  data: { products: CarouselProductMapperInput[] };
  errors: { message: string }[];
};

type GetCarouselProps = {
  query: string;
  variables: CarouselVariables;
  locale: string;
  environment: string;
};

export const getCarousel = async ({ query, variables, locale, environment }: GetCarouselProps) => {
  const origin = getOriginFromEnvironment(locale, environment);

  const response = await API.post<CarouselBody, CarouselResponse>({
    path: `${origin}/api/graphql`,
    body: { query, variables: { ...variables, locale } },
  });

  // The Graphql api endpoint returns errors without the response.ok being false or the status 550
  // Thats why we need to cover the errors here because they come with the normal response 200.
  // Graphql errors explained: https://the-guild.dev/blog/graphql-error-handling-with-fp
  if (response.errors) {
    throw new Error(response.errors.map(error => error.message).join('\n'));
  } else {
    return response.data;
  }
};
